import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../../../filters';

export default {
  name: 'statementDiscount',
  components: {
    
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      appData: []
    }
  },
  created() {
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.$root.$on('statement_discount_updated', this.init);
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;
        this.appData = this.dataObj.appData;
      });
    },
  },
}
